import React from 'react';
import {Grid} from '@material-ui/core'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import CheckBoxInputAnsvarig from '../Inputs/CheckBoxInputAnsvarig'
import CheckBoxInputType from '../Inputs/CheckBoxInputType'
import CheckBoxInputTaggning from '../Inputs/CheckBoxInputTaggning'
import CheckBoxInputDistrikt from '../Inputs/CheckBoxInputDistrikt'
import UtokningAnRapport from '../UtokningAnRapport'
import {useSelector} from 'react-redux'
import {isEmpty} from 'lodash'

function RapportAm(props) {
    const CurrentObjekt = useSelector(state => state.accountsData.CurrentObjekt)
    const Flags = useSelector(state => state.accountsData.Flags) 
    return (
        <>
            <Grid
            container
            direction="row"
            alignItems="center"
            >
               <Grid item xs={3} className={"p-1"}> 
                    <CheckBoxInput Meta="Kund namn" disabled={true}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Kund orgnr" disabled={true} Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                <CheckBoxInput Meta="Kundnr" disabled={true} Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputAnsvarig Meta="Ansvarig" disabled={true} Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Adress" disabled={false} Value={false} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                <CheckBoxInput Meta="Extra adress" disabled={false} Value={false} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                <CheckBoxInput Meta="Telefon" disabled={false} Value={false} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                <CheckBoxInput Meta="Extra telefon" disabled={false} Value={false} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                <CheckBoxInput Meta="Kund epost" disabled={false} Value={false} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputType Meta="Kundtyp" disabled={false} Value={false} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Kundstatus" disabled={false} Value={false} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputTaggning Meta="Taggning" disabled={false} Value={false} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                {
                    parseInt(Flags.Distrikt) === 1?
                    <Grid item xs={3} className={"p-1"}>
                        <CheckBoxInputDistrikt Meta="Distrikt" disabled={false} Value={false} 
                        onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                    </Grid>
                    :""
                }
                <UtokningAnRapport 
                onChangeMstate={props.onChangeMstate} Mstate={props.Mstate} 
                />
                {
                            isEmpty(CurrentObjekt)?"":
                            CurrentObjekt.map(item=>{
                                  return <Grid item xs={3} className={"p-1"}> 
                                    <CheckBoxInput 
                                    Meta={`Fria fält ${item.Meta}`} 
                                    disabled={false} 
                                    Value={false} 
                                    onChangeMstate={props.onChangeMstate} 
                                    Mstate={props.Mstate}/></Grid>
                               
                            })
                        }
            </Grid>
        </>
    );
}

export default RapportAm;